import { render } from "./EmployeeForm.vue?vue&type=template&id=c7580fac&ts=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__